import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="text-white py-3" style={{ background: 'var(--color-primary)' }}>
      <div className="container">
        <div className="text-center">
          <p className="mb-1" style={{ fontSize: '0.9rem' }}>
            © {currentYear} CEC Track, Inc., All Rights Reserved.
          </p>
          <p className="mb-0" style={{ fontSize: '0.85rem' }}>
            <Link 
              to="/terms-of-service" 
              className="text-white me-3"
              style={{ textDecoration: 'none' }}
            >
              Terms of Service
            </Link>
            <Link 
              to="/privacy-policy" 
              className="text-white me-3"
              style={{ textDecoration: 'none' }}
            >
              Privacy Policy
            </Link>
            <Link 
              to="/contact" 
              className="text-white"
              style={{ textDecoration: 'none' }}
            >
              Contact Us
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
